// extracted by mini-css-extract-plugin
module.exports = {"graphDayPlaceholder":"DayPlaceholder_graphDayPlaceholder__WazjP"};